import { BmarkRiskPricingErrorDisplayModel } from "./BmarkSpotRiskDisplay.model";

export class InstrumentColumnData {
  constructor(
    public instrument: string,
    public pricingError: BmarkRiskPricingErrorDisplayModel,
    public isPositionWarning: boolean,
    public isPositionAlert: boolean,
  ) {
    // NOP
  }

  public toString(): string {
    // we just return this - as that is what is used to sort columns containing one of these.
    return this.instrument;
  }
}
